import { ComponentDocs } from "components/docs";
import { ComponentExample } from "components/examples";

const TableSelectableColumn = () => (
  <ComponentDocs
    name="<Table.SelectableColumn/>"
    entry="SelectableColumn"
    propsEntry="SelectableColumnProps"
    namespace="TableColumns"
  >
    <ComponentExample
      name="Select page"
      description="By default the header checkbox will select all rows on the current page."
      import={import("examples/Tables/TableSelectableColumn/SelectPageExample")}
      rawImport={import(
        "examples/Tables/TableSelectableColumn/SelectPageExample?raw"
      )}
    />
    <ComponentExample
      name="Select all"
      description="The header checkbox can optionally select every rows across across all pages."
      import={import("examples/Tables/TableSelectableColumn/SelectAllExample")}
      rawImport={import(
        "examples/Tables/TableSelectableColumn/SelectAllExample?raw"
      )}
    />
    <ComponentExample
      name="Can select"
      description="The canSelect and canSelectAll props can control which rows are selectable."
      import={import("examples/Tables/TableSelectableColumn/CanSelectExample")}
      rawImport={import(
        "examples/Tables/TableSelectableColumn/CanSelectExample?raw"
      )}
    />
    <ComponentExample
      name="Custom selection rendering"
      import={import(
        "examples/Tables/TableSelectableColumn/CustomSelectionRenderingExample"
      )}
      rawImport={import(
        "examples/Tables/TableSelectableColumn/CustomSelectionRenderingExample?raw"
      )}
    />
  </ComponentDocs>
);

export default TableSelectableColumn;
